export const articleKey = 'article';
export const scheduleKey = 'schedule';
